module.exports = __webpack_public_path__ + "static/media/6.f5401f80.jpg";